export class FileExtended {
    id: number;
    convertedFileSize: string;
    file: File;
}